export default __webpack_public_path__ + "24cd6d56a19bc2b36e0ac43ddb71da26.png";